/**
 * Em'z Blendz Custom Subscription Widget v15
 * Fixed: Reads actual discount % from selling plan data instead of hardcoding 10%
 * Supports Guest Toiletries (5%) and main Subscribe & Save (10%) groups
 */

(function () {
  'use strict';

  // The Soap on a Rope product carries selling plans only so it can renew
  // alongside a subscribed bar (see emz-rope-addon.js). Do not offer a
  // standalone rope subscription on its own page. Seal's native widget is
  // already hidden globally by emz-subscription-widget.css.
  if (window.location.pathname.indexOf('/products/products-soap-on-a-rope-customizable') !== -1) {
    return;
  }

  // Service add-on products (tag "service-addon") suppress all purchase
  // UI, this widget included. The product template marks their section
  // with data-service-addon; this script is deferred, so the marker is
  // in the DOM by the time the guard runs.
  if (document.querySelector('[data-service-addon]')) {
    return;
  }

  document.addEventListener('sealsubs:subscription_widget_created', function (e) {
    initCustomWidget();
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initCustomWidget, 500);
  });



  /**
   * Detect actual discount percentage from the product's selling plan data.
   * Checks Seal's rendered widget text first, then variant allocation data.
   * Falls back to 10% if neither source is available.
   */
  function getDiscountPercent() {
    // Method 1: Read from Seal's own rendered widget (most reliable - Seal already resolved the group)
    const sealContainer = document.querySelector('.sealsubs-container');
    if (sealContainer) {
      const match = sealContainer.textContent.match(/SAVE\s+(\d+)%/i);
      if (match) {
        console.log('EMZ Widget: Discount from Seal widget:', match[1] + '%');
        return parseInt(match[1]);
      }
    }

    // Method 2: Parse variant JSON selling_plan_allocations
    const variantTextarea = document.querySelector('textarea[data-variant-json]');
    if (variantTextarea) {
      try {
        const variants = JSON.parse(variantTextarea.textContent);
        if (variants && variants[0] && variants[0].selling_plan_allocations && variants[0].selling_plan_allocations.length > 0) {
          const alloc = variants[0].selling_plan_allocations[0];
          if (alloc.compare_at_price && alloc.price && alloc.compare_at_price > 0) {
            const discount = Math.round((1 - alloc.price / alloc.compare_at_price) * 100);
            console.log('EMZ Widget: Discount from variant data:', discount + '%');
            return discount;
          }
        }
      } catch (e) {
        console.log('EMZ Widget: Could not parse variant JSON for discount', e);
      }
    }

    // Fallback
    console.log('EMZ Widget: Using default 10% (could not detect from product data)');
    return 10;
  }

  function initCustomWidget() {
    const sealContainer = document.querySelector('.sealsubs-container');
    if (!sealContainer || document.querySelector('.emz-subscription-widget')) return;

    const sellingPlans = getSellingPlans();
    if (!sellingPlans || sellingPlans.length === 0) return;

    const originalPrice = getOriginalPrice();
    const discountPercent = getDiscountPercent();
    console.log('EMZ Widget: Original price:', originalPrice, '| Discount:', discountPercent + '%');

    const widget = buildWidget(sellingPlans, originalPrice, discountPercent);

    // Find the best place to insert
    let insertTarget = sealContainer;
    let insertParent = sealContainer.parentNode;

    let current = sealContainer;
    while (current && current.parentNode) {
      if (current.classList && (
        current.classList.contains('product-block') ||
        current.classList.contains('shopify-block') ||
        current.classList.contains('shopify-app-block')
      )) {
        insertTarget = current;
        insertParent = current.parentNode;
        break;
      }
      current = current.parentNode;
    }

    // When Seal injects inside the native buy block, present the purchase
    // choice before its form. Standalone app blocks keep their native order.
    const ownsPurchaseForm = insertTarget.querySelector('form.product-single__form [data-add-to-cart]');
    insertParent.insertBefore(widget, ownsPurchaseForm ? insertTarget : insertTarget.nextSibling);
    selectOption('onetime');

    // Listen for variant changes from theme.js
    document.addEventListener('emz:variantChange', function (e) {
      if (e.detail && e.detail.price) {
        updateWidgetPrices(e.detail.price);
      }
    });
  }

  function updateWidgetPrices(newPrice) {
    const widget = document.querySelector('.emz-subscription-widget');
    if (!widget) return;

    console.log('EMZ Widget: Updating prices to:', newPrice);

    // Update stored original price
    widget.dataset.originalPrice = newPrice;

    // Read discount from stored data attribute (set during buildWidget)
    const discountPercent = parseInt(widget.dataset.discountPercent) || 10;
    const discountedPrice = newPrice * (1 - discountPercent / 100);

    // Update One-Time Price
    const onetimeOption = widget.querySelector('.emz-sub-option[data-type="onetime"]');
    if (onetimeOption) {
      const priceEl = onetimeOption.querySelector('.emz-sub-price');
      if (priceEl) {
        priceEl.textContent = '$' + newPrice.toFixed(2);
      }
    }

    // Update Subscribe & Save Price
    const subscribeOption = widget.querySelector('.emz-sub-option[data-type="subscribe"]');
    if (subscribeOption) {
      const priceEl = subscribeOption.querySelector('.emz-sub-price');
      if (priceEl) {
        priceEl.innerHTML = `
          <span class="emz-sub-price-compare">$${newPrice.toFixed(2)}</span>
          $${discountedPrice.toFixed(2)}
        `;
      }
    }
  }

  function getOriginalPrice() {
    // Method 1: Parse JSON-LD schema (most reliable)
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Product' && data.offers) {
          const variantInput = document.querySelector('input[name="id"], select[name="id"]');
          const variantId = variantInput ? variantInput.value : null;

          const offers = Array.isArray(data.offers) ? data.offers : [data.offers];
          for (const offer of offers) {
            if (variantId && offer.url && offer.url.includes(variantId)) {
              if (offer.price) {
                return parseFloat(offer.price);
              }
            }
          }
          if (offers[0] && offers[0].price) {
            return parseFloat(offers[0].price);
          }
        }
      } catch (e) {
        console.log('EMZ Widget: JSON-LD parse error', e);
      }
    }

    // Method 2: Shopify Analytics
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      const product = window.ShopifyAnalytics.meta.product;
      const variantInput = document.querySelector('input[name="id"]');
      const variantId = variantInput ? variantInput.value : null;

      if (product.variants) {
        const variant = product.variants.find(v => v.id == variantId) || product.variants[0];
        if (variant && variant.price) {
          return parseFloat(variant.price);
        }
      }
    }

    // Method 3: Meta tag
    const metaPrice = document.querySelector('meta[property="product:price:amount"]');
    if (metaPrice) {
      return parseFloat(metaPrice.content);
    }

    return null;
  }

  function getSellingPlans() {
    const sealSelect = document.querySelector('.sealsubs-container select.sls-select');
    if (sealSelect) {
      const plans = [];
      sealSelect.querySelectorAll('option').forEach(opt => {
        if (opt.value) {
          plans.push({
            id: opt.value,
            name: opt.textContent.trim(),
            interval: parseInterval(opt.textContent)
          });
        }
      });
      if (plans.length > 0) return plans;
    }

    return [
      { id: '6850117698', name: 'Every 1 Month', interval: 1 },
      { id: '6850150466', name: 'Every 2 Months', interval: 2 },
      { id: '6850183234', name: 'Every 3 Months', interval: 3 },
      { id: '6850216002', name: 'Every 4 Months', interval: 4 },
      { id: '6850248770', name: 'Every 5 Months', interval: 5 },
      { id: '6850281538', name: 'Every 6 Months', interval: 6 }
    ];
  }

  function parseInterval(text) {
    const match = text.match(/(\d+)/);
    if (match) return parseInt(match[1]);
    return 1;
  }

  function buildWidget(plans, originalPrice, discountPercent) {
    const discountedPrice = originalPrice ? (originalPrice * (1 - discountPercent / 100)) : null;

    const widget = document.createElement('div');
    widget.className = 'emz-subscription-widget product-block';
    widget.dataset.originalPrice = originalPrice || '';
    widget.dataset.discountPercent = discountPercent;

    let onetimePriceHTML = '';
    let subscribePriceHTML = '';

    if (originalPrice) {
      onetimePriceHTML = `<span class="emz-sub-price">$${originalPrice.toFixed(2)}</span>`;
      subscribePriceHTML = `
        <span class="emz-sub-price">
          <span class="emz-sub-price-compare">$${originalPrice.toFixed(2)}</span>
          $${discountedPrice.toFixed(2)}
        </span>
      `;
    }

    widget.innerHTML = `
      <span class="emz-sub-label">Purchase Options</span>
      
      <div class="emz-sub-options" role="radiogroup" aria-label="Purchase options">
        <div class="emz-sub-option" data-type="onetime" role="radio" aria-checked="false" tabindex="-1">
          <div class="emz-sub-option-left">
            <div class="emz-sub-radio">
              <div class="emz-sub-radio-dot"></div>
            </div>
            <div class="emz-sub-option-text">
              <span class="emz-sub-option-name">One-Time Purchase</span>
            </div>
          </div>
          ${onetimePriceHTML}
        </div>
        
        <div class="emz-sub-option" data-type="subscribe" role="radio" aria-checked="false" tabindex="-1">
          <div class="emz-sub-option-left">
            <div class="emz-sub-radio">
              <div class="emz-sub-radio-dot"></div>
            </div>
            <div class="emz-sub-option-text">
              <span class="emz-sub-option-name">Subscribe & Save</span>
              <span class="emz-sub-benefit">Delivered on your schedule. Cancel anytime.</span>
              <span class="emz-sub-badge">Save ${discountPercent}%</span>
            </div>
          </div>
          ${subscribePriceHTML}
        </div>
      </div>
      
      <div class="emz-sub-frequency" id="emz-frequency-selector">
        <label class="emz-freq-label" for="emz-delivery-frequency">Delivery frequency</label>
        <select class="emz-freq-native" id="emz-delivery-frequency">
        </select>
      </div>
      
      <div class="emz-sub-footer">
        <a href="/pages/subscribe" class="emz-sub-details-link">
          <span>Subscription details</span>
          <span class="emz-link-arrow">→</span>
        </a>
        <span class="emz-sub-flexibility-note">Skip, Edit or Cancel Anytime</span>
      </div>
    `;

    const frequencySelect = widget.querySelector('.emz-freq-native');
    plans.forEach(plan => {
      const option = document.createElement('option');
      option.value = plan.id;
      option.textContent = formatFrequency(plan.name);
      frequencySelect.appendChild(option);
    });

    const purchaseOptions = Array.from(widget.querySelectorAll('.emz-sub-option'));
    purchaseOptions.forEach((opt, index) => {
      opt.addEventListener('click', function () { selectOption(this.dataset.type); });
      opt.addEventListener('keydown', function (e) {
        let next = index;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % purchaseOptions.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index + purchaseOptions.length - 1) % purchaseOptions.length;
        else if (e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        selectOption(purchaseOptions[next].dataset.type);
        purchaseOptions[next].focus();
      });
    });
    widget.querySelector('.emz-freq-native').addEventListener('change', function () {
      updateSealSellingPlan(this.value);
    });

    return widget;
  }

  function selectOption(type) {
    const widget = document.querySelector('.emz-subscription-widget');
    if (!widget) return;

    widget.querySelectorAll('.emz-sub-option').forEach(opt => {
      const isActive = opt.dataset.type === type;
      opt.classList.toggle('active', isActive);
      opt.setAttribute('aria-checked', String(isActive));
      opt.tabIndex = isActive ? 0 : -1;
      if (opt.dataset.type === 'subscribe') {
        opt.classList.toggle('has-frequency', isActive);
      }
    });

    const freqSelector = widget.querySelector('.emz-sub-frequency');
    if (type === 'subscribe') {
      freqSelector.classList.add('visible');
      const frequency = widget.querySelector('.emz-freq-native');
      if (frequency.value) updateSealSellingPlan(frequency.value);
    } else {
      freqSelector.classList.remove('visible');
      updateSealSellingPlan('');
    }
  }

  function formatFrequency(text) {
    const label = text.trim();
    const match = label.match(/^(?:every\s+)?(?:(\d+)\s+)?(day|week|month|year)(s)?$/i);
    if (!match) return label;
    const count = match[1] ? Number(match[1]) : 1;
    if (!Number.isSafeInteger(count) || count < 1 || (!match[1] && match[3])) return label;
    const unit = match[2].toLowerCase();
    return 'Every ' + count + ' ' + unit[0].toUpperCase() + unit.slice(1) + (count === 1 ? '' : 's');
  }

  function updateSealSellingPlan(planId) {
    const sealInput = document.querySelector('input[name="selling_plan"]');
    if (sealInput) sealInput.value = planId;

    const sealSelect = document.querySelector('.sealsubs-container select.sls-select');
    if (sealSelect) {
      sealSelect.value = planId;
      sealSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (window.SealSubs && typeof window.SealSubs.changeSelectedSellingPlanId === 'function') {
      window.SealSubs.changeSelectedSellingPlanId(planId);
    }

    document.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
      detail: { selling_plan_id: planId }
    }));
  }

})();
